import { render, staticRenderFns } from "./DxPlannedVsReal.vue?vue&type=template&id=21d447b0&scoped=true&"
import script from "./DxPlannedVsReal.vue?vue&type=script&lang=js&"
export * from "./DxPlannedVsReal.vue?vue&type=script&lang=js&"
import style0 from "./DxPlannedVsReal.vue?vue&type=style&index=0&id=21d447b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d447b0",
  null
  
)

export default component.exports